<template>
  <div class="container" id="editBookingPage">
    <div class="nav">
      <div class="loading-wrapper" :class="{'loading-show': bookingLoading}">
        <div class="loading-spinner"></div>
      </div>
      <div class="row pb-menu-permalink">
        <div class="col-12 text-center booking-logo" v-if="bookingClinic.logo">
          <img :src="bookingClinic.logo.url" :alt="bookingClinic.clinic_name" :title="bookingClinic.clinic_name"/>
        </div>
        <div class="tab-content">
          <transition name="fade" mode="out-in" v-on:before-enter="beforeEnter" duration="200">
            <div :key="bookingEditStep" class="pt-5 m-auto">
              <EditBookingCalendar v-if="bookingEditStep === 'EditBookingCalendar'" />
              <BookingConfirm v-if="bookingEditStep === 'BookingEditConfirm'" />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BookingConfirm from '../../components/booking/BookingConfirm.vue'
import EditBookingCalendar from '../../components/booking/EditBookingCalendar.vue'
export default {
  name: 'BookingEdit',
  components: {
    BookingConfirm,
    EditBookingCalendar
  },
  computed: {
    ...mapGetters('booking_edit', ['bookingClinic', 'bookingEditStep', 'bookingLoading'])
  },
  methods: {
    ...mapActions('booking_edit', ['getBooking']),
    beforeEnter(el) {
      window.scrollTo(0,0);
    }
  },
  mounted() {
    this.getBooking(this.$route.params.id);
  }
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
